//the layer and filter sidebar text are in layer.translation.ts
//the selected feature sidebar texts are in map.translations.ts
export const SIDEBAR_TRANSLATIONS = {
  //Main menu / sidebar
  view: {
    de: 'Darstellung',
    en: 'Appearance',
    fr: 'Apparence',
  },
  viewArchivedOperation: {
    de: 'Dies ist ein archiviertes Ereignis',
    en: 'Ceci est un événement archivé',
    fr: 'Ceci est un événement archivé',
  },
  history: {
    de: 'History- / Lese-Modus',
    en: 'History / read mode',
    fr: 'Mode historique / lecture',
  },
  toastHistory: {
    de: 'Lesemodus aktiviert',
    en: 'Reading mode enabled',
    fr: 'Mode lecture activé',
  },
  drawMode: {
    de: 'Zeichnungsmodus',
    en: 'Drawing mode',
    fr: 'Mode de dessin',
  },
  toastDrawing: {
    de: 'Zeichnenmodus aktiviert',
    en: 'Drawing mode enabled',
    fr: 'Mode dessin activé',
  },
  language: {
    de: 'Sprache',
    en: 'Language',
    fr: 'Langue',
  },
  de: {
    de: 'Deutsch',
    en: 'German',
    fr: 'Allemand',
  },
  fr: {
    de: 'Französisch',
    en: 'French',
    fr: 'Français',
  },
  en: {
    de: 'Englisch',
    en: 'English',
    fr: 'Anglais',
  },
  listView: {
    de: 'Listenansicht',
    en: 'List view',
    fr: 'Vue liste',
  },
  listViewTable: {
    de: 'Tabelle anzeigen',
    en: 'Show Table',
    fr: 'Afficher Tableau',
  },
  saveAsExcel: {
    de: 'Als Excel exportieren',
    en: 'Export as Excel',
    fr: 'Exporter en Excel',
  },
  changeTable: {
    de: 'Änderungsprotokoll',
    en: 'Change log',
    fr: 'Journal des modifications',
  },
  personRecoveryOverview: {
    de: 'Personenbergungsübersicht',
    en: 'Person recovery overview',
    fr: 'Aperçu des personnes hébergées',
  },
  noMissingPersons: {
    de: 'Keine Auswirkungen auf Personen gefunden',
    en: 'No impacts on persons found',
    fr: 'Aucun effet sur les personnes',
  },
  resourceOverview: {
    de: 'Mittelübersicht',
    en: 'Resource overview',
    fr: 'Aperçu des ressources',
  },
  noResources: {
    de: 'Keine Ressourcen vorhanden',
    en: 'No resources available',
    fr: 'Aucune ressource disponible',
  },
  expertView: {
    de: 'Experten Ansicht',
    en: 'Expert view',
    fr: "Point de vue d'expert",
  },
  defaultView: {
    de: 'Standard Ansicht',
    en: 'Default view',
    fr: 'Vue générale',
  },
  toastExpertView: {
    de: 'Experten Ansicht aktiviert',
    en: 'Expert view activated',
    fr: "Point de vue d'expert activé",
  },
  toastDefaultView: {
    de: 'Standard Ansicht aktiviert',
    en: 'Default view activated',
    fr: 'Vue générale activée',
  },
  journalMessageTextTemplate: {
    de: 'Textvorlage für neue Journal Meldungen',
    en: 'Text template for new journal entries',
    fr: 'Modèle de texte pour les nouvelles entrées de journal',
  },

  //share
  share: {
    de: 'Freigeben',
    en: 'Share',
    fr: 'Partager',
  },
  generateMultiUseShareLink: {
    de: 'Mehrfach-Link generieren',
    en: 'Generate share link',
    fr: 'Copier le lien de partage',
  },
  generateSingleUseShareLink: {
    de: 'Einweg-Link generieren',
    en: 'Generate one way link',
    fr: 'Copier le qr code de partage',
  },
  manageAccess: {
    de: 'Freigabelinks verwalten',
    en: 'Manage share links',
    fr: 'Arranger les liens de partage',
  },
  expiresOn: {
    de: 'Ablaufdatum',
    en: 'Expires on',
    fr: 'Date dexpiration',
  },
  read: {
    de: 'Lesen',
    en: 'Read',
    fr: 'Lire',
  },
  write: {
    de: 'Schreiben',
    en: 'Write',
    fr: 'Ecrire',
  },
  shareLinks: {
    de: 'Freigabelinks Übersicht',
    en: 'Overview of sharing links',
    fr: 'Aperçu des liens de partage',
  },
  noShareLinks: {
    de: 'Es sind keine Links für diese Operation vorhanden.',
    en: 'There are no links available for this operation.',
    fr: "Aucun lien n'est disponible pour cette opération.",
  },
  rewokeShareLinkFailedMessage: {
    de: 'Fehler beim löschen des Links.',
    en: 'Error while deleting the link.',
    fr: 'Erreur lors de la suppression du lien.',
  },
  copiedToClipboard: {
    de: 'In Zwischenablage kopiert',
    en: 'Copied to clipboard',
    fr: 'Copié dans le presse-papiers',
  },
  navigateOperations: {
    de: 'Zurück zu Ereignisse',
    en: 'Back to events',
    fr: 'Retour aux événements',
  },
  logout: {
    de: 'Logout',
    en: 'Logout',
    fr: 'Logout',
  },

  //listView / drawn element export
  listViewTitle: {
    de: 'Listenansicht aller aktuellen Kartenelemente',
    en: 'List view of all current map elements',
    fr: 'Vue de liste de tous les éléments de carte actuels',
  },
  csvSearchFor: {
    de: 'Suche nach ...',
    en: 'Search for ...',
    fr: 'Chercher ...',
  },
  csvID: {
    de: 'ID',
    en: 'ID',
    fr: 'ID',
  },
  csvDate: {
    de: 'Erstelldatum',
    en: 'Date created',
    fr: 'Date de création',
  },
  csvGroup: {
    de: 'Gruppe',
    en: 'Group',
    fr: 'Groupe',
  },
  csvGroupArea: {
    de: 'Bereich',
    en: 'Area',
    fr: 'Zone',
  },
  csvSignatur: {
    de: 'Signatur',
    en: 'Sign',
    fr: 'Signature',
  },
  csvCentroid: {
    de: 'Koordinaten Zentrum',
    en: 'Centroid',
    fr: 'Centre coordonnées',
  },
  csvLocation: {
    de: 'Koordinaten',
    en: 'Coordinates',
    fr: 'Coordonnées',
  },
  csvReportNumber: {
    de: 'Meldenummer',
    en: 'Report number',
    fr: 'Numéro de rapport',
  },
  csvSize: {
    de: 'Grösse',
    en: 'Size',
    fr: 'Dimension',
  },
  csvLabel: {
    de: 'Bezeichnung',
    en: 'Label',
    fr: 'Désignation',
  },
  csvDescription: {
    de: 'Beschreibung',
    en: 'Description',
    fr: 'Description',
  },
  listViewExport: {
    de: 'ListenansichtExport',
    en: 'ListViewExport',
    fr: 'ExporterVueListe',
  },

  //changeTable / changeset table representation export
  changeTableTitle: {
    de: 'Änderungsprotokoll',
    en: 'Changelog',
    fr: 'Journal des modifications',
  },
  csvShowTechnicalFields: {
    de: 'technische Felder anzeigen',
    en: 'show technical fields',
    fr: 'afficher les champs techniques',
  },
  csvChangesetId: {
    de: 'Änderungs ID',
    en: 'Changeset ID',
    fr: 'ID du changeset',
  },
  csvChangeDate: {
    de: 'Änderungsdatum',
    en: 'Change date',
    fr: 'Date de modification',
  },
  csvSignValid: {
    de: 'Signature gültig',
    en: 'Signature valid',
    fr: 'Signature valide',
  },
  csvAuthor: {
    de: 'Autor',
    en: 'Author',
    fr: 'Auteur',
  },
  csvElemId: {
    de: 'Element ID',
    en: 'Element ID',
    fr: "Identifiant de l'élément",
  },
  csvAction: {
    de: 'Aktion',
    en: 'Action',
    fr: 'Action',
  },
  csvChangedProperties: {
    de: 'Geänderte Felder',
    en: 'Changed fields',
    fr: 'Champs modifiés',
  },
  csvCoordChange: {
    de: 'Koordinatenänderung',
    en: 'Coordinate Change',
    fr: 'Changement de coordonnées',
  },
  changeTableExport: {
    de: 'AenderungsProtokollExport',
    en: 'ChangeLogExport',
    fr: 'Exportation du journal des modifications',
  },

  //changeset conflict sidebar
  changeset: {
    de: 'Changeset',
    en: 'Changeset',
    fr: 'Changeset',
  },

  //version info
  version: {
    de: 'Version',
    en: 'Version',
    fr: 'Version',
  },
  changelog: {
    de: 'Änderungsprotokoll',
    en: 'Changelog',
    fr: 'Journal des modifications',
  },
  versionNotCompatible: {
    de: 'Die UI Version ist nicht mit dem Server kompatibel. Mache einen hard refresh (Ctrl+F5 oder cmd+option+r) um das UI neu zu laden.',
    en: 'The UI version is not compatible with the server. Perform a hard refresh (Ctrl+F5 or cmd+option+r) to reload the UI.',
    fr: "La version de l'interface utilisateur n'est pas compatible avec le serveur. Effectuez une actualisation forcée (Ctrl+F5 ou cmd+option+r) pour recharger l'interface utilisateur.",
  },
  newVersion: {
    de: 'Neue UI Version verfügbar {0}, aktive Version {1}',
    en: 'New UI version available {0}, active version {1}',
    fr: "Nouvelle version de l'interface utilisateur disponible {0}, version active {1}",
  },
  reloadPage: {
    de: 'Seite neu laden',
    en: 'Reload page',
    fr: 'Recharger la page',
  },
  noChangeLogAvaliable: {
    de: 'Kein Änderungsprotokoll verfügbar.',
    en: 'No change log available.',
    fr: 'Aucun journal des modifications disponible.',
  },

  //user / offline data sidebar
  connections: {
    de: 'Verbindungen',
    en: 'Connections',
    fr: 'Connexions',
  },
  myName: {
    de: 'Mein Name',
    en: 'My name',
    fr: 'Mon nom',
  },
  enterYourName: {
    de: 'Bitte geben Sie Ihren Namen ein',
    en: 'Please enter your name',
    fr: 'Veuillez entrer votre nom',
  },
  shareLocation: {
    de: 'Standort teilen',
    en: 'Share location',
    fr: 'Partager la position',
  },
  online: {
    de: 'Online',
    en: 'Online',
    fr: 'En ligne',
  },
  youAreOffline: {
    de: 'Sie sind offline',
    en: 'You are offline',
    fr: 'Vous êtes hors ligne',
  },
  currentLocation: {
    de: 'Aktuelle position',
    en: 'Current location',
    fr: 'Emplacement actuel',
  },

  offlineData: {
    de: 'Offline Daten',
    en: 'Offline data',
    fr: 'Données hors ligne',
  },
  localAvailabilityStepsIntro: {
    de: 'Um offline arbeiten zu können, müssen diverse Dinge überprüft/vorbereitet werden.',
    en: 'To be able to work offline, various things need to be checked/prepared:',
    fr: 'Pour pouvoir travailler hors ligne, plusieurs éléments doivent être vérifiés/préparés.',
  },
  prepareLocalAvailability: {
    de: 'Offline arbeiten vorbereiten',
    en: 'Prepare work offline',
    fr: 'Préparer le travail hors ligne',
  },
  useLocalBaseMap: {
    de: '"Lokal" Basiskarte vewenden.',
    en: 'Use "Local" base map.',
    fr: 'Utiliser la carte de base "Local".',
  },
  downloadLocalBaseMap: {
    de: '"Lokal" Basiskarte herunterladen.',
    en: 'Download "local" base map.',
    fr: 'Télécharger la carte de base "locale".',
  },
  hideUnavailableLayers: {
    de: 'Alle Kartenebenen ohne Offline-Funktion ausblenden (/entfernen).',
    en: 'Hide(/remove) all map layers without offline capability.',
    fr: 'Masquer (/supprimer) toutes les couches de carte sans fonctionnalité hors ligne.',
  },
  downloadAvailableLayers: {
    de: 'Daten aller aktiven Kartenebenen mit Offline-Funktion herunterladen.',
    en: 'Download data from all active map layers with offline capability.',
    fr: 'Téléchargez les données de toutes les couches de carte actives avec une fonctionnalité hors ligne.',
  },
  haveSearchCapability: {
    de: 'Verwenden von Kartenebene(n) mit Offline-Suchfunktion.',
    en: 'Use map layer(s) with offline search capability.',
    fr: 'Utilisez des couches de carte avec une fonctionnalité de recherche hors ligne.',
  },
  howtoFindSearchCapability: {
    de: 'Kartenebene(n) mit Offline-Suchfunktion zeigen in der Liste der „Verfügbaren Ebenen“ ein Lupensymbol an und gehören zur Ebenen Quelle "ZSKarte verwaltete Ebenen" oder "Geteilte Ebenen".',
    en: 'Map layer(s) with offline search capability show a Magnifying glass symbol on the list of "Available layers" and they are of "ZSKarte managed layers" or "Shared layers" Layer Source.',
    fr: 'Les couches de carte avec capacité de recherche hors ligne affichent un symbole de loupe sur la liste des "Couches cartographiques disponibles" et elles appartiennent à la source de couche "Couches gérées par ZSKarte" ou "Couches partagées".',
  },

  //history sidebar
  currentState: {
    de: 'Aktuell',
    en: 'Most recent',
    fr: 'Actuel',
  },
  currentStateActive: {
    de: 'Aktuelle Karte',
    en: 'Most recent map',
    fr: 'Actuel map',
  },
  snapshotTimestamp: {
    de: 'Sicherungszeitpunkt',
    en: 'Backup time',
    fr: 'Date de sauvegarde',
  },
  noSnapshots: {
    de: 'Keine Sicherungen gefunden',
    en: 'No backups found',
    fr: 'Aucune sauvegarde trouvée',
  },
  toastSnapshotApplied: {
    de: 'Sicherung angewendet',
    en: 'Backup applied',
    fr: 'Sauvegarde appliqué',
  },

  //print sidebar
  paperFormat: {
    de: 'Papierformat',
    en: 'paper format',
    fr: 'Format papier',
  },
  orientation: {
    de: 'Orientierung',
    en: 'orientation',
    fr: 'orientation',
  },
  landscape: {
    de: 'Querformat',
    en: 'landscape',
    fr: 'format paysage',
  },
  portrait: {
    de: 'Hochformat',
    en: 'portrait',
    fr: 'format portrait',
  },
  printMargin: {
    de: 'Druckrand',
    en: 'Print margin',
    fr: 'Marge imprimante',
  },
  resolution: {
    de: 'Auflösung',
    en: 'resolution',
    fr: 'résolution',
  },
  autoScale: {
    de: 'Automatische Skalierung',
    en: 'auto scale',
    fr: 'échelle automatique',
  },
  printScale: {
    de: 'Massstab drucken',
    en: 'Print scale',
    fr: "imprimer l'échelle",
  },
  hideAllInfos: {
    de: 'alle Signaturen und Informationen ausblenden',
    en: 'hide all signatures and infos',
    fr: 'masquer toutes les signatures et informations',
  },
  qrCode: {
    de: 'QR-Code',
    en: 'QR code',
    fr: 'code QR',
  },
  emptyMap: {
    de: 'Leere Karte',
    en: 'empty map',
    fr: 'carte vide',
  },
  addQRCode: {
    de: 'QR-Code hinzufügen',
    en: 'Add QR code',
    fr: 'Ajouter un code QR',
  },
  withShare: {
    de: 'mit Freigabe',
    en: 'with share',
    fr: 'avec partage',
  },
  generatePdf: {
    de: 'PDF generieren',
    en: 'generate PDF',
    fr: 'générer le PDF',
  },
  deactivateWebGL: {
    de: 'Der angeforderte Export ist zu gross für den WebGL-Renderer. Seite mit deaktivierter WebGL-Unterstützung neu laden?',
    en: 'The requested export is too large for the WebGL renderer. Reload the page with WebGL support disabled?',
    fr: "L'exportation demandée est trop volumineuse pour le moteur de rendu WebGL. Recharger la page avec le support WebGL désactivé?",
  },
};
